export const colors = ["#90c08c", "#74a3ff", "#c38cc0", "#ffd49f"];
